import { createContext } from "react";

const runContext = createContext();
export default runContext;